import { graphql } from 'react-relay';

import { StuffWindowPaginator_query$key } from '../../../relay/__generated__/StuffWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const StuffWindowPaginator_query = graphql`
  fragment StuffWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: StuffFilter }
    order: { type: StuffOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int, defaultValue: 20 }
  )
  @refetchable(queryName: "StuffWindowPaginatorRefreshQuery") {
    stuffs(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...StuffConnectionDataTable_stuffConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<StuffWindowPaginator_query$key>, 'fragment'>;

const StuffWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={StuffWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.stuffs.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default StuffWindowPaginator;
